import { DEFAULT_API_CONFIG } from './apiConfig';
import queryString from 'query-string';

const { url, getHeaders } = DEFAULT_API_CONFIG;
const baseRoute = `${url}/SelfInspect`;

export const getSelfInspect = async orderKey => {
  const url = `${baseRoute}/${orderKey}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });

  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const saveSelfInspectAnswers = async (inspectionKey, answers, questionId, orderFormHeaderId) => {
  const queryParams = queryString.stringify({
    questionId: questionId,
  });

  const url = !!orderFormHeaderId
    ? `${baseRoute}/${inspectionKey}/SaveOutbuildingAnswers/${orderFormHeaderId}?${queryParams}`
    : `${baseRoute}/${inspectionKey}/SaveAnswers?${queryParams}`;

  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'PUT',
    headers,
    body: JSON.stringify(answers),
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const uploadSelfInspectImages = async (inspectionKey, questionId, images) => {
  const url = `${baseRoute}/${inspectionKey}/Images/${questionId}`;
  let headers = getHeaders();
  delete headers['Content-Type'];

  const formData = new FormData();

  images.map(image => {
    formData.append('files', image);
  });

  const response = await fetch(url, {
    method: 'POST',
    body: formData,
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const uploadSelfInspectImage = async (inspectionKey, questionId, image, orderFormHeaderId) => {
  const queryParams = queryString.stringify({
    orderFormHeaderId: orderFormHeaderId,
  });
  const url = `${baseRoute}/${inspectionKey}/Image/${questionId}?${queryParams}`;

  let headers = getHeaders();
  delete headers['Content-Type'];

  const formData = new FormData();

  formData.append('file', image);

  const response = await fetch(url, {
    method: 'POST',
    body: formData,
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const deleteSelfInspectImage = async (inspectionKey, formImageId, orderFormHeaderId) => {
  const queryParams = queryString.stringify({
    orderFormHeaderId: orderFormHeaderId,
  });
  let url = `${baseRoute}/${inspectionKey}/Image/${formImageId}?${queryParams}`;

  let headers = getHeaders();

  const response = await fetch(url, {
    method: 'DELETE',
    headers,
  });
  //const json = await response.json();
  return response.ok ?? Promise.reject();
};

export const submitSelfInspect = async inspectionKey => {
  const url = `${baseRoute}/${inspectionKey}/Submit`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'POST',
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const updateInVisionIQPhoneNumber = async (inspectionKey, phoneNumber) => {
  const queryParams = queryString.stringify({
    phoneNumber: phoneNumber,
  });

  const url = `${baseRoute}/AgentConfirmation/${inspectionKey}?${queryParams}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'POST',
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const addQuickVueLog = async log => {
  const url = `${baseRoute}/${log.orderLineGuid}/QuickVueLog`;
  let headers = getHeaders();

  const response = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(log),
    headers,
  });

  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const addOutbuilding = async (orderLineGuid, numberOfOutbuildings) => {
  const url = `${baseRoute}/${orderLineGuid}/Outbuilding?numberOfOutbuildings=${numberOfOutbuildings}`;
  let headers = getHeaders();

  const response = await fetch(url, {
    method: 'POST',
    headers,
  });

  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const deleteOutbuilding = async (orderLineGuid, orderFormHeaderId) => {
  const url = `${baseRoute}/${orderLineGuid}/Outbuilding/${orderFormHeaderId}`;
  let headers = getHeaders();

  const response = await fetch(url, {
    method: 'DELETE',
    headers,
  });

  return response.ok;
};
